import { render } from "./Norterra.vue?vue&type=template&id=0e0c4ac4"
import script from "./Norterra.vue?vue&type=script&lang=js"
export * from "./Norterra.vue?vue&type=script&lang=js"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__